module.exports = __webpack_public_path__ + "img/scattered clouds.05ce5c70.jpg";